// 卫生间家具
import bathBasinUrl from '@/assets/furnitures/bath_basin.png'
import bathDoorUrl from '@/assets/furnitures/bath_door.png'
import bathFloorUrl from '@/assets/furnitures/bath_floor.png'
import bathShowerUrl from '@/assets/furnitures/bath_shower.png'
import bathToiletUrl from '@/assets/furnitures/bath_toilet.png'

// 卧室家具
import bedCabinetUrl from '@/assets/furnitures/bed_cabinet.png'
import bedDressingChairUrl from '@/assets/furnitures/bed_dressing_chair.png'
import bedDressingMirrorUrl from '@/assets/furnitures/bed_dressing_mirror.png'
import bedFloorUrl from '@/assets/furnitures/bed_floor.png'
import bedTableUrl from '@/assets/furnitures/bed_table.png'
import bedUrl from '@/assets/furnitures/bed.png'

// 餐厅家具
import diningChairUrl from '@/assets/furnitures/dining_chair.png'
import diningFloorUrl from '@/assets/furnitures/dining_floor.png'
import diningFridgeUrl from '@/assets/furnitures/dining_fridge.png'
import diningTableRectUrl from '@/assets/furnitures/dining_table_rect.png'
import diningTableUrl from '@/assets/furnitures/dining_table.png'

// 客厅家具
import livingFloorBookcaseUrl from '@/assets/furnitures/living_bookcase.png'
import livingFloorUrl from '@/assets/furnitures/living_floor.png'
import livingSofaUrl from '@/assets/furnitures/living_sofa.png'
import livingSofaSingleUrl from '@/assets/furnitures/living_sofa_single.jpg'
import livingTeaTableUrl from '@/assets/furnitures/living_tea_table.png'
import livingTvStandUrl from '@/assets/furnitures/living_tv_stand.png'

// 其他
import radarUrl from '@/assets/furnitures/radar.png'

export type FurnitureIconType =
  | 'bed'
  | 'bed_cabinet'
  | 'bed_dressing_chair'
  | 'bed_dressing_mirror'
  | 'bed_floor'
  | 'bed_table'
  | 'bath_basin'
  | 'bath_door'
  | 'bath_floor'
  | 'bath_shower'
  | 'bath_toilet'
  | 'dining_chair'
  | 'dining_floor'
  | 'dining_fridge'
  | 'dining_table_rect'
  | 'dining_table'
  | 'living_bookcase'
  | 'living_floor'
  | 'living_sofa'
  | 'living_sofa_single'
  | 'living_tea_table'
  | 'living_tv_stand'
  | 'radar'

export const furnitureIconUrlMap: Record<FurnitureIconType, string> = {
  bed: bedUrl,
  bed_cabinet: bedCabinetUrl,
  bed_dressing_chair: bedDressingChairUrl,
  bed_dressing_mirror: bedDressingMirrorUrl,
  bed_floor: bedFloorUrl,
  bed_table: bedTableUrl,
  bath_basin: bathBasinUrl,
  bath_door: bathDoorUrl,
  bath_floor: bathFloorUrl,
  bath_shower: bathShowerUrl,
  bath_toilet: bathToiletUrl,
  dining_chair: diningChairUrl,
  dining_floor: diningFloorUrl,
  dining_fridge: diningFridgeUrl,
  dining_table_rect: diningTableRectUrl,
  dining_table: diningTableUrl,
  living_bookcase: livingFloorBookcaseUrl,
  living_floor: livingFloorUrl,
  living_sofa: livingSofaUrl,
  living_sofa_single: livingSofaSingleUrl,
  living_tea_table: livingTeaTableUrl,
  living_tv_stand: livingTvStandUrl,
  radar: radarUrl,
}

export const furnitureIconNameMap: Record<FurnitureIconType, string> = {
  bed: '床',
  bed_cabinet: '柜子',
  bed_dressing_chair: '化妆椅',
  bed_dressing_mirror: '化妆镜',
  bed_floor: '地板',
  bed_table: '床头柜',
  bath_basin: '脸盆',
  bath_door: '门',
  bath_floor: '地板',
  bath_shower: '淋浴',
  bath_toilet: '马桶',
  dining_table_rect: '方形餐桌',
  dining_table: '餐桌',
  dining_chair: '餐椅',
  dining_floor: '地板',
  dining_fridge: '冰箱',
  living_bookcase: '书柜',
  living_floor: '地板',
  living_sofa: '沙发',
  living_sofa_single: '单人沙发',
  living_tea_table: '茶几',
  living_tv_stand: '电视柜',
  radar: '雷达',
}

export const furnitureIconSizeMap = {
  bed: {
    width: 80,
    height: 70,
  },
  bed_cabinet: {
    width: 40,
    height: 80,
  },
  bed_dressing_chair: {
    width: 40,
    height: 40,
  },
  bed_dressing_mirror: {
    width: 40,
    height: 80,
  },
  bed_floor: {
    width: 40,
    height: 40,
  },
  bed_table: {
    width: 40,
    height: 40,
  },
  bath_basin: {
    width: 40,
    height: 80,
  },
  bath_door: {
    width: 40,
    height: 40,
  },
  bath_floor: {
    width: 40,
    height: 40,
  },
  bath_shower: {
    width: 40,
    height: 60,
  },
  bath_toilet: {
    width: 40,
    height: 40,
  },
  dining_table_rect: {
    width: 40,
    height: 40,
  },
  dining_table: {
    width: 40,
    height: 80,
  },
  dining_chair: {
    width: 40,
    height: 80,
  },
  dining_floor: {
    width: 40,
    height: 40,
  },
  dining_fridge: {
    width: 40,
    height: 80,
  },
  living_bookcase: {
    width: 40,
    height: 80,
  },
  living_floor: {
    width: 40,
    height: 40,
  },
  living_sofa: {
    width: 40,
    height: 80,
  },
  living_sofa_single: {
    width: 40,
    height: 40,
  },
  living_tea_table: {
    width: 40,
    height: 80,
  },
  living_tv_stand: {
    width: 40,
    height: 80,
  },
  radar: {
    width: 20,
    height: 20,
  },
}

export const furnitureIconMapHandler = (
  icon: FurnitureIconType
): { name: string; width: number; height: number } => {
  return {
    name: furnitureIconNameMap[icon],
    width: furnitureIconSizeMap[icon].width,
    height: furnitureIconSizeMap[icon].height,
  }
}
